// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAuditLogChangesetInfoDto } from './IAuditLogChangesetInfoDto';
import {
    IAuditLogChangesetInfoDtoFromJSON,
    IAuditLogChangesetInfoDtoFromJSONTyped,
    IAuditLogChangesetInfoDtoToJSON,
    IAuditLogChangesetInfoDtoToJSONTyped,
} from './IAuditLogChangesetInfoDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageAuditLogChangesetInfoDto
 */
export interface IPageAuditLogChangesetInfoDto {
    /**
     * 
     * @type {number}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IAuditLogChangesetInfoDto>}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    content?: Array<IAuditLogChangesetInfoDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageAuditLogChangesetInfoDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageAuditLogChangesetInfoDto interface.
 */
export function instanceOfIPageAuditLogChangesetInfoDto(value: object): value is IPageAuditLogChangesetInfoDto {
    return true;
}

export function IPageAuditLogChangesetInfoDtoFromJSON(json: any): IPageAuditLogChangesetInfoDto {
    return IPageAuditLogChangesetInfoDtoFromJSONTyped(json, false);
}

export function IPageAuditLogChangesetInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageAuditLogChangesetInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IAuditLogChangesetInfoDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageAuditLogChangesetInfoDtoToJSON(json: any): IPageAuditLogChangesetInfoDto {
    return IPageAuditLogChangesetInfoDtoToJSONTyped(json, false);
}

export function IPageAuditLogChangesetInfoDtoToJSONTyped(value?: IPageAuditLogChangesetInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IAuditLogChangesetInfoDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

